module.exports = __webpack_public_path__ + "img/Factory 2.9b07212a.svg";